import fetch from '../utils/fetch';
// import fetch from '../utils/fetch'
import { baseUrl } from '../utils/env';


export const ajaxAutoWithList = (data) => {
  return fetch(baseUrl + '/api/withdrawalAuto/getAutoWithList', data);
};
export const ajaxOperateBalance = (data) => {
  return fetch(baseUrl + '/api/crm/setBalance', data);
};
export const ajaxBalanceList = (data) => {
  return fetch(baseUrl + '/api/crm/getBalanceList', data);
};
export const ajaxInfo = (data) => {
  return fetch(baseUrl + '/api/getGithub', data);
};

//获取链上转账结果
export const ajaxBuybackStatus = (data) => {
  return fetch(baseUrl + '/api/withdrawal/getBuybackStatus', data);
};
//设备解绑
export const ajaxUnbindDev = (data) =>{
  return fetch(baseUrl + '/api/crm/unbindDev', data);
}






//获取账单权限
export const ajaxGetBillAuth = (data) =>{
  return fetch(baseUrl + '/api/bill/getBillAuth', data);
}
//获取业务方
export const ajaxGetBusiness = (data) => {
  return fetch(baseUrl + '/api/bill/getBusiness', data);
}
//计算账单、同时用来记录用户动作（计算、下载、删除、上传）
export const ajaxCalculateBill = (data) =>{
  return fetch(baseUrl + '/api/bill/calculateBill', data);
}
//获取账单操作列表
export const ajaxGetBillRecordList = (data) =>{
  return fetch(baseUrl + '/api/bill/getBillRecordList', data);
}
//供给方上传账单
export const ajaxUploadSupplyBill = (data) => {
  return fetch(baseUrl + '/api/bill/uploadSupplyBill', data);
}
//删除供给方账单
export const ajaxDelSupplyBill = (data) => {
  return fetch(baseUrl + '/api/bill/delSupplyBill', data, 'POST');
}
